import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";

import Home from "./Home";
import About from "./About";
import Poems from "./Poems";
import Shop from "./Shop";
import Contact from "./Contact";
import Banner from "./Banner";
import Sidebar from "./Sidebar";

function AppWrapper() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [overlayOpacity] = useState(0.5);
  const sentinelRef = useRef(null);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMenuOpen(false); // close menu if open
    }
  };

  // Close menu on route change
  useEffect(() => setMenuOpen(false), [location.pathname]);

  // Banner and overlay scroll logic
  useEffect(() => {
    if (location.pathname !== "/") {
      setShowBanner(true);
      return;
    }
    setShowBanner(false);

    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowBanner(!entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: "-400px 0px 0px 0px",
      }
    );

    // const paragraph = document.querySelector(".animated-text");

    // const lines = paragraph.innerText
    //   .split(". ")
    //   .filter((line) => line.trim() !== "");

    // paragraph.innerHTML = lines
    //   .map((line) => `<span>${line.trim()}.</span>`)
    //   .join("");

    // const spans = paragraph.querySelectorAll("span");
    // spans.forEach((span, index) => {
    //   span.style.animationDelay = `${index * 0.6}s`; // 0.6s per line
    // });

    if (sentinelRef.current) observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [location.pathname]);

  return (
    <div className="App">
      {/* Menu toggle */}
      <button
        className={`menu-toggle ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        ☰
      </button>

      {/* Navigation */}
      <nav>
        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          <button onClick={() => scrollToSection("home")}>Home</button>
          <button onClick={() => scrollToSection("about")}>About</button>
          <button onClick={() => scrollToSection("poems")}>Poems</button>
          {/* <button onClick={() => scrollToSection("shop")}>Shop</button> */}
          <button onClick={() => scrollToSection("contact")}>Contact</button>
        </div>
      </nav>

      {/* Banner */}
      <Banner text="Jolanta Hildebrandt-Mazurek" visible={showBanner} />

      {/* Overlay */}
      <div
        className="overlay"
        style={{ "--overlay-opacity": overlayOpacity }}
      ></div>

      <section id="home" className="homepage">
        <Home sentinelRef={sentinelRef} />
      </section>

      {/* <section id="poems" className="container-poems">
        <Poems />
      </section> */}

      <main className="page-grid">
        <aside className="sidebar">
          <Sidebar />
        </aside>
        <div className="main-content">
          <section id="about" className="container">
            <About />
          </section>
          <section id="poems" className="container">
            <Poems />
          </section>
          <section id="contact" className="container">
            <Contact />
          </section>
        </div>
      </main>
      <div className="container-footer">
        © {new Date().getFullYear()} Jolanta Hildebrandt-Mazurek
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
